import { Grid } from '@mui/material';

import { InfoField } from '@occc/ui-design-system';
import { AwardCappedMoneyDiscountFragment } from '@occc/graphql';
import { formatMoneyAmount } from '@occc-app/lib/currency';

type CappedMoneyDiscountAwardProps = {
  award: AwardCappedMoneyDiscountFragment;
};

export const CappedMoneyDiscountAward = ({ award }: CappedMoneyDiscountAwardProps) => {
  return (
    <Grid container spacing={2}>
      <Grid item sm={3}>
        <InfoField
          label='Money Amount'
          value={formatMoneyAmount(award.moneyAmount, { fromCents: true })}
        />
      </Grid>
    </Grid>
  );
};
